/* unplugin-vue-components disabled */import { render } from "./DeviceDetailTemp.vue?vue&type=template&id=10857cb8&scoped=true&ts=true"
import script from "./DeviceDetailTemp.vue?vue&type=script&lang=ts"
export * from "./DeviceDetailTemp.vue?vue&type=script&lang=ts"

import "./DeviceDetailTemp.vue?vue&type=style&index=0&id=10857cb8&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10857cb8"]])

export default __exports__